import React from 'react';

import { IMainLayoutDomainStore } from './IMainLayoutDomainStore';
import { LayoutDomainContext } from './LayoutDomainContext';

type Injected = { layoutDomain: IMainLayoutDomainStore };

export const withLayoutDomain = <P extends Injected>(Component: React.ComponentType<P>) => {
  const Wrapped = (props: Omit<P, keyof Injected>) => {
    return (
      <LayoutDomainContext.Consumer>
        {(layoutDomain) => {
          if (!layoutDomain) {
            throw new Error('withLayoutDomain must be used inside <LayoutDomainContext.Provider>');
          }
          return <Component {...(props as P)} layoutDomain={layoutDomain} />;
        }}
      </LayoutDomainContext.Consumer>
    );
  };

  Wrapped.displayName = `withLayoutDomain(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
};
